module.exports = __webpack_public_path__ + "img/ryback.06587dc3.png";